import { FlexBox, Colors, PostFixWrapper, NavbarLogoName } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { createGlobalStyle, css } from "styled-components";

export const SimpleLogoContainer = styled(FlexBox)<{ isMedia?: boolean}>`
`;

export const LogoWrapper = styled.div`
  ${PostFixWrapper} {
    padding-top: 0;
  }
  
  ${NavbarLogoName} {
    font-size: 22px;
    padding-top: 0;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
      font-size: 17px;
      line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
      margin-left: 0!important;
    }
  }
`

export const LogoWrapperWhite = styled.div<any>`
  ${p => p.isKiiidsArt && css`
    div {
      margin-left: 0;
    }
      svg {
        ${p.isOpen? css`
          rect, path {
            stroke: #94209E;
          }
        `
        : 
         css`rect {
          fill: #94209E;
        }`}
      }
    `}
  ${NavbarLogoName} {
    @media (max-width: ${LayoutConst.screen.l}px) {
      margin-left: 0!important;
    }
  }
`

export const DafesStyles = createGlobalStyle`

  ${LogoWrapper} div, ${LogoWrapper} span {
    font-family: Inter;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: ${Colors.galBlack100} !important;

    @media (max-width: ${LayoutConst.screen.m}px) {
      font-size: 17px;
      line-height: 22px;
    }
  }

  ${LogoWrapper} span {
    margin-left: 8px;
  }
`import { FlexBox, Colors, PostFixWrapper, NavbarLogoName } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { createGlobalStyle, css } from "styled-components";

export const SimpleLogoContainer = styled(FlexBox)<{ isMedia?: boolean}>`
`;

export const LogoWrapper = styled.div`
  ${PostFixWrapper} {
    padding-top: 0;
  }
  
  ${NavbarLogoName} {
    font-size: 22px;
    padding-top: 0;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
      font-size: 17px;
      line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
      margin-left: 0!important;
    }
  }
`

export const LogoWrapperWhite = styled.div<any>`
  ${p => p.isKiiidsArt && css`
    div {
      margin-left: 0;
    }
      svg {
        ${p.isOpen? css`
          rect, path {
            stroke: #94209E;
          }
        `
        : 
         css`rect {
          fill: #94209E;
        }`}
      }
    `}
  ${NavbarLogoName} {
    @media (max-width: ${LayoutConst.screen.l}px) {
      margin-left: 0!important;
    }
  }
`

export const DafesStyles = createGlobalStyle`

  ${LogoWrapper} div, ${LogoWrapper} span {
    font-family: Inter;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: ${Colors.galBlack100} !important;

    @media (max-width: ${LayoutConst.screen.m}px) {
      font-size: 17px;
      line-height: 22px;
    }
  }

  ${LogoWrapper} span {
    margin-left: 8px;
  }
`